import React from 'react';
import { Link } from 'react-router-dom';
import WhatsAppServiceButton from '../components/WhatsAppServiceButton';
import SEOHeadNative from '../components/SEOHeadNative';
import AdSpot from '../components/AdSpot';

const Home: React.FC = () => {
  // Données structurées pour le SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ElectricalContractor",
    "name": "OZARKS ELEC",
    "alternateName": "OZARKSELEC",
    "description": "Électricien et entreprise générale de bâtiment à Viesly. Spécialiste en électricité, rénovation, maintenance industrielle, domotique et formation habilitation électrique.",
    "url": "https://ozarkselec.com",
    "telephone": "+33630984578",
    "email": "ozarkselec@gmail.com",
    "image": "https://ozarkselec.com/images/ozarkselec-logo-bleu.png",
    "logo": "https://ozarkselec.com/images/ozarkselec-logo-bleu.png",
    "priceRange": "€€",
    "currenciesAccepted": "EUR",
    "paymentAccepted": "Virement bancaire, Chèque, Espèces",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "16 Rue de Prayelle",
      "addressLocality": "Viesly",
      "postalCode": "59271",
      "addressRegion": "Hauts-de-France",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 50.068,
      "longitude": 3.427
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "19:00"
      }
    ],
    "areaServed": [
      {
        "@type": "City",
        "name": "Viesly",
        "sameAs": "https://fr.wikipedia.org/wiki/Viesly"
      },
      {
        "@type": "City",
        "name": "Cambrai"
      },
      {
        "@type": "City",
        "name": "Caudry"
      },
      {
        "@type": "City",
        "name": "Le Cateau-Cambrésis"
      },
      {
        "@type": "City",
        "name": "Saint-Quentin"
      },
      {
        "@type": "City",
        "name": "Valenciennes"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Aisne (02)"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Nord (59)"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Thiérache"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Caudrésis-Catésis"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services OZARKS ELEC",
      "itemListElement": [
        {
          "@type": "OfferCatalog",
          "name": "Électricité",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Installation électrique neuve" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Rénovation et mise aux normes électrique" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Dépannage électrique" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Domotique et éclairage LED" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Tableau électrique" } }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Bâtiment général",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Rénovation intérieure complète" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Isolation thermique" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Pose de parquet et revêtements" } }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Mobilité électrique",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Installation borne de recharge IRVE" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Borne de recharge particuliers" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Borne de recharge entreprises" } }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Industrie & Formation",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Maintenance industrielle préventive et curative" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Formation habilitation électrique NF C18-510" } }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Enseignes lumineuses",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Installation enseignes lumineuses et croix de pharmacie" } }
          ]
        }
      ]
    },
    "knowsAbout": [
      "Norme NF C 15-100",
      "Norme NF C18-510",
      "Certification IRVE",
      "Certification Legrand"
    ],
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61555968326960"
    ]
  };

  return (
    <div>
      <SEOHeadNative
        title="OZARKS ELEC - Électricien & Entreprise générale de bâtiment à Viesly"
        description="Électricien professionnel et entreprise générale de bâtiment à Viesly (59271). Installation électrique, rénovation, maintenance industrielle, domotique, formation habilitation électrique. Intervention dans l'Aisne, la Thiérache et le Nord."
        keywords="électricien Viesly, électricité Aisne, entreprise bâtiment Nord, rénovation électrique, maintenance industrielle, domotique, habilitation électrique, installation électrique, OZARKS ELEC, électricien 59271"
        canonical="/"
        structuredData={structuredData}
      />
      <div id="rec802607343" className="r t-rec">
        <div id="services" style={{fontSize: 0}}></div>
      </div>
      
      <div id="rec804709737" className="r t-rec t-rec_pt_60 t-rec_pb_30" style={{paddingTop: '60px', paddingBottom: '30px'}}>
        <div className="t795">
          <div className="t-container t-align_center">
            <div className="t-col t-col_10 t-prefix_1">
              <h1 className="t795__title t-title t-title_xs t-margin_auto">
                <br />
                <span className="ozarks-blue-dark">Ozarks</span>
                <span className="ozarks-blue-medium">elec</span>
                <br />
                <span className="ozarks-dark">Électricien & Entreprise générale de bâtiment</span>
                <br />
                <span className="ozarks-blue-dark mobile-subtitle">Électricité • Rénovation • Construction</span>
                <br /><br />
                <strong className="ozarks-dark">Que vous soyez </strong>
                <strong className="ozarks-blue-dark">Professionnel </strong>
                <span className="ozarks-dark">ou </span>
                <strong className="ozarks-blue-dark">Particulier</strong>
              </h1>
              <div className="t795__descr t-descr t-descr_xl t-margin_auto">
                <div style={{fontSize: '28px'}} className="ozarks-gray">
                  Découvrez une <strong className="ozarks-blue-dark">large palette d'activités</strong>
                  <br />
                  répondant à tous vos <strong className="ozarks-blue-dark">besoins</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="rec809697294" className="r t-rec t-rec_pt_45 t-rec_pb_45" style={{paddingTop: '45px', paddingBottom: '45px'}}>
        <div className="t029">
          <div className="t029__container t-container">
            <div className="t029__col t-col t-col_8">
              <div className="t029__linewrapper" style={{opacity: 0.5}}>
                <div className="t029__opacity t029__opacity_left"></div>
                <div className="t-divider t029__line" style={{background: '#222d5a'}}></div>
                <div className="t029__opacity t029__opacity_right"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section Spot Publicitaire */}
      <AdSpot imageSrc="/images/blc-spot.jpg" audioSrc="/audio/spot.mp4" />

      <div id="rec809693322" className="r t-rec t-rec_pt_60 t-rec_pb_60" style={{paddingTop: '60px', paddingBottom: '60px'}}>
        <div className="t692">
          <div className="t-section__container t-container t-container_flex">
            <div className="t-col t-col_12">
              <div className="t-section__title t-title t-title_xs t-align_center t-margin_auto">
                <div style={{fontSize: '42px'}} className="ozarks-blue-dark">
                  Nos <span className="ozarks-blue-medium">services</span>
                </div>
                <div className="t-descr t-descr_xl t-margin_auto" style={{marginTop: '20px', color: 'var(--ozarks-gray)'}}>
                  De l'électricité au bâtiment général, découvrez toute notre expertise
                </div>
              </div>
            </div>
          </div>
          
          <div className="t-container" style={{marginTop: '40px'}}>
            <div className="services-container">
              {/* Première ligne - 3 services */}
              <div className="services-row row-3">
                {/* 1. Électricité Générale */}
                <div className="service-item t-card__col t-card__col_withoutbtn t692__col t-align_center t-item">
                  <Link to="/elecgnrle" className="t692__blockimg t692__blockimg_3-2 t692__blockimg_large" style={{
                      borderRadius: '20px',
                      display: 'block',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <img src="/images/tild3665-3636-4066-b331-386236343766__image_de_fond.png" alt="Électricité générale - Installation et dépannage électrique" style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}} />
                  </Link>
                  <div className="t692__textwrapper">
                    <div className="t-card__title t-heading t-heading_sm">
                      <Link to="/elecgnrle" className="t-card__link ozarks-blue-dark">
                        Électricité Générale
                      </Link>
                      <div className="t-descr" style={{color: 'var(--ozarks-gray)', fontSize: '14px', marginTop: '10px'}}>
                        Installations, dépannages et mises aux normes
                      </div>
                      <WhatsAppServiceButton serviceName="Électricité Générale" />
                    </div>
                  </div>
                </div>

                {/* 2. Bâtiment Général */}
                <div className="service-item t-card__col t-card__col_withoutbtn t692__col t-align_center t-item">
                  <Link to="/batiment" className="t692__blockimg t692__blockimg_3-2 t692__blockimg_large" style={{
                      borderRadius: '20px',
                      display: 'block',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <img src="/images/batiment/finition-interieure.jpg" alt="Bâtiment général - Rénovation et finitions intérieures" style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}} />
                  </Link>
                  <div className="t692__textwrapper">
                    <div className="t-card__title t-heading t-heading_sm">
                      <Link to="/batiment" className="t-card__link ozarks-blue-dark">
                        Bâtiment Général
                      </Link>
                      <div className="t-descr" style={{color: 'var(--ozarks-gray)', fontSize: '14px', marginTop: '10px'}}>
                        Rénovation, isolation et pose de parquet
                      </div>
                      <WhatsAppServiceButton serviceName="Bâtiment Général" />
                    </div>
                  </div>
                </div>

                {/* 3. IRVE - Bornes de Recharge */}
                <div className="service-item t-card__col t-card__col_withoutbtn t692__col t-align_center t-item">
                  <Link to="/irve" className="t692__blockimg t692__blockimg_3-2 t692__blockimg_large" style={{
                      borderRadius: '20px',
                      display: 'block',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <img src="/images/tild3166-6234-4933-b961-643361313737__borne.png" alt="IRVE - Installation de bornes de recharge pour véhicules électriques" style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}} />
                  </Link>
                  <div className="t692__textwrapper">
                    <div className="t-card__title t-heading t-heading_sm">
                      <Link to="/irve" className="t-card__link ozarks-blue-dark">
                        IRVE - Bornes de Recharge
                      </Link>
                      <div className="t-descr" style={{color: 'var(--ozarks-gray)', fontSize: '14px', marginTop: '10px'}}>
                        Installation certifiée pour véhicules électriques
                      </div>
                      <WhatsAppServiceButton serviceName="IRVE - Bornes de Recharge" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Deuxième ligne - 3 services */}
              <div className="services-row row-3">
                {/* 4. Maintenance Industrielle */}
                <div className="service-item t-card__col t-card__col_withoutbtn t692__col t-align_center t-item">
                  <Link to="/maintenindus" className="t692__blockimg t692__blockimg_3-2 t692__blockimg_large" style={{
                      borderRadius: '20px',
                      display: 'block',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <img src="/images/tild3361-3439-4461-b464-323133306335__2148976366.jpg" alt="Maintenance industrielle - Dépannage et maintenance préventive" style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}} />
                  </Link>
                  <div className="t692__textwrapper">
                    <div className="t-card__title t-heading t-heading_sm">
                      <Link to="/maintenindus" className="t-card__link ozarks-blue-dark">
                        Maintenance Industrielle
                      </Link>
                      <div className="t-descr" style={{color: 'var(--ozarks-gray)', fontSize: '14px', marginTop: '10px'}}>
                        Maintenance préventive et curative
                      </div>
                      <WhatsAppServiceButton serviceName="Maintenance Industrielle" />
                    </div>
                  </div>
                </div>

                {/* 5. Habilitation Électrique */}
                <div className="service-item t-card__col t-card__col_withoutbtn t692__col t-align_center t-item">
                  <Link to="/habielec" className="t692__blockimg t692__blockimg_3-2 t692__blockimg_large" style={{
                      borderRadius: '20px',
                      display: 'block',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <img src="/images/tild3033-3662-4530-a236-636430373231__cartoon_electrician_.jpg" alt="Formation habilitation électrique certifiée" style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}} />
                  </Link>
                  <div className="t692__textwrapper">
                    <div className="t-card__title t-heading t-heading_sm">
                      <Link to="/habielec" className="t-card__link ozarks-blue-dark">
                        Habilitation Électrique
                      </Link>
                      <div className="t-descr" style={{color: 'var(--ozarks-gray)', fontSize: '14px', marginTop: '10px'}}>
                        Formation et certification sécurisée
                      </div>
                      <WhatsAppServiceButton serviceName="Habilitation Électrique" />
                    </div>
                  </div>
                </div>

                {/* 6. Enseignes Lumineuses */}
                <div className="service-item t-card__col t-card__col_withoutbtn t692__col t-align_center t-item">
                  <Link to="/enseignes" className="t692__blockimg t692__blockimg_3-2 t692__blockimg_large" style={{
                      borderRadius: '20px',
                      display: 'block',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <img src="/images/croix-pharmacie.svg" alt="Enseignes lumineuses - Croix de pharmacie et panneaux LED" style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}} />
                  </Link>
                  <div className="t692__textwrapper">
                    <div className="t-card__title t-heading t-heading_sm">
                      <Link to="/enseignes" className="t-card__link ozarks-blue-dark">
                        Enseignes Lumineuses
                      </Link>
                      <div className="t-descr" style={{color: 'var(--ozarks-gray)', fontSize: '14px', marginTop: '10px'}}>
                        Croix de pharmacie, enseignes LED et panneaux lumineux
                      </div>
                      <WhatsAppServiceButton serviceName="Enseignes Lumineuses" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section Marques Partenaires - Version Professionnelle */}
      <div className="r t-rec t-rec_pt_80 t-rec_pb_80" style={{paddingTop: '80px', paddingBottom: '80px', backgroundColor: 'var(--ozarks-light-gray)'}}>
        <div className="t-container">
          <div className="t-col t-col_12">
            <div className="t-align_center">
              <h2 className="t-section__title t-title t-title_xs t-margin_auto" style={{marginBottom: '15px'}}>
                <span className="ozarks-blue-dark">Nos marques</span> <span className="ozarks-blue-medium">partenaires</span>
              </h2>
              <div className="t-descr t-descr_xl t-margin_auto" style={{marginBottom: '50px', color: 'var(--ozarks-gray)', maxWidth: '600px'}}>
                Nous travaillons exclusivement avec les leaders mondiaux de l'électricité et de la domotique
              </div>
              
              {/* Catégories de marques */}
              <div style={{maxWidth: '1100px', margin: '0 auto'}}>
                
                {/* Équipement Électrique */}
                <div style={{marginBottom: '50px'}}>
                  <h3 style={{
                    fontSize: '18px',
                    fontWeight: 600,
                    color: 'var(--ozarks-blue-dark)',
                    marginBottom: '25px',
                    textAlign: 'left',
                    borderBottom: '2px solid var(--ozarks-blue-light)',
                    paddingBottom: '8px'
                  }}>
                    ⚡ Équipement Électrique
                  </h3>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '25px',
                    alignItems: 'center'
                  }}>
                    
                    <div style={{
                      backgroundColor: 'white',
                      padding: '25px 20px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px var(--ozarks-shadow)',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      border: '1px solid #f0f0f0'
                    }} onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px var(--ozarks-shadow-medium)';
                    }} onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px var(--ozarks-shadow)';
                    }}>
                      <img src="/images/tild3631-3266-4331-a133-616432613361__legrand-logo-768x480.png" alt="Legrand" style={{maxHeight: '60px', width: 'auto', marginBottom: '8px'}} />
                      <p style={{fontSize: '13px', color: 'var(--ozarks-blue-dark)', margin: '0', fontWeight: 600}}>🇫🇷 Marque française</p>
                      <p style={{fontSize: '11px', color: 'var(--ozarks-gray)', margin: '0 0 8px 0'}}>Appareillage électrique</p>
                      <img src="/images/certiflegrand.jpg" alt="Électricien Certifié Legrand" style={{maxWidth: '100%', height: 'auto', borderRadius: '6px'}} />
                    </div>
                    
                  </div>
                </div>

                {/* Domotique & Éclairage */}
                <div style={{marginBottom: '50px'}}>
                  <h3 style={{
                    fontSize: '18px',
                    fontWeight: 600,
                    color: 'var(--ozarks-blue-dark)',
                    marginBottom: '25px',
                    textAlign: 'left',
                    borderBottom: '2px solid var(--ozarks-blue-light)',
                    paddingBottom: '8px'
                  }}>
                    🏠 Domotique & Éclairage
                  </h3>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '25px',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      backgroundColor: 'white',
                      padding: '25px 20px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px var(--ozarks-shadow)',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      border: '1px solid #f0f0f0'
                    }} onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px var(--ozarks-shadow-medium)';
                    }} onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px var(--ozarks-shadow)';
                    }}>
                      <img src="/images/tild3263-3139-4330-b233-643261336436__somfy-domotique.png" alt="Somfy" style={{maxHeight: '50px', width: 'auto', marginBottom: '10px'}} />
                      <p style={{fontSize: '12px', color: 'var(--ozarks-gray)', margin: '0'}}>Automatismes</p>
                    </div>
                    
                    <div style={{
                      backgroundColor: 'white',
                      padding: '25px 20px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px var(--ozarks-shadow)',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      border: '1px solid #f0f0f0'
                    }} onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px var(--ozarks-shadow-medium)';
                    }} onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px var(--ozarks-shadow)';
                    }}>
                      <img src="/images/tild3761-3535-4664-a232-373530393634__logo_delta_dore.png" alt="Delta Dore" style={{maxHeight: '50px', width: 'auto', marginBottom: '10px'}} />
                      <p style={{fontSize: '12px', color: 'var(--ozarks-gray)', margin: '0'}}>Domotique</p>
                    </div>
                    
                    <div style={{
                      backgroundColor: 'white',
                      padding: '25px 20px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px var(--ozarks-shadow)',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      border: '1px solid #f0f0f0'
                    }} onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px var(--ozarks-shadow-medium)';
                    }} onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px var(--ozarks-shadow)';
                    }}>
                      <img src="/images/tild3064-3266-4331-a332-303063333638__philips-logopng1.png" alt="Philips" style={{maxHeight: '50px', width: 'auto', marginBottom: '10px'}} />
                      <p style={{fontSize: '12px', color: 'var(--ozarks-gray)', margin: '0'}}>Éclairage LED</p>
                    </div>
                  </div>
                </div>

                {/* Sécurité & Mobilité */}
                <div>
                  <h3 style={{
                    fontSize: '18px',
                    fontWeight: 600,
                    color: 'var(--ozarks-blue-dark)',
                    marginBottom: '25px',
                    textAlign: 'left',
                    borderBottom: '2px solid var(--ozarks-blue-light)',
                    paddingBottom: '8px'
                  }}>
                    🔒 Sécurité & Mobilité Électrique
                  </h3>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '25px',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      backgroundColor: 'white',
                      padding: '25px 20px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px var(--ozarks-shadow)',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      border: '1px solid #f0f0f0'
                    }} onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px var(--ozarks-shadow-medium)';
                    }} onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px var(--ozarks-shadow)';
                    }}>
                      <img src="/images/tild3466-6136-4139-b365-323366326236__aiphone.png" alt="Aiphone" style={{maxHeight: '50px', width: 'auto', marginBottom: '10px'}} />
                      <p style={{fontSize: '12px', color: 'var(--ozarks-gray)', margin: '0'}}>Interphonie</p>
                    </div>
                    
                    <div style={{
                      backgroundColor: 'white',
                      padding: '25px 20px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px var(--ozarks-shadow)',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      border: '1px solid #f0f0f0'
                    }} onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px var(--ozarks-shadow-medium)';
                    }} onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px var(--ozarks-shadow)';
                    }}>
                      <img src="/images/tild3861-3638-4465-a531-623733383138__wallbox.png" alt="Wallbox" style={{maxHeight: '50px', width: 'auto', marginBottom: '10px'}} />
                      <p style={{fontSize: '12px', color: 'var(--ozarks-gray)', margin: '0'}}>Bornes de recharge</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div style={{
                marginTop: '50px',
                padding: '25px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 4px 15px var(--ozarks-shadow)',
                maxWidth: '700px',
                margin: '50px auto 0'
              }}>
                <h4 style={{color: 'var(--ozarks-blue-dark)', marginBottom: '15px', fontSize: '16px', fontWeight: 600}}>
                  💡 Notre engagement qualité
                </h4>
                <p style={{color: 'var(--ozarks-gray)', fontSize: '14px', lineHeight: '1.6', margin: '0'}}>
                  Nous sélectionnons rigoureusement nos partenaires pour vous garantir des installations durables, 
                  performantes et conformes aux dernières normes en vigueur.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section Nos Réalisations */}
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_10 t-prefix_1">
            <div className="t-align_center">
              <h2 className="t-section__title t-title t-title_xs t-margin_auto" style={{marginBottom: '20px'}}>
                <span className="ozarks-blue-dark">Nos</span> <span className="ozarks-blue-medium">réalisations</span>
              </h2>
              <div className="t-descr t-descr_xl t-margin_auto" style={{marginBottom: '50px', color: 'var(--ozarks-gray)', maxWidth: '600px'}}>
                Découvrez quelques-unes de nos réalisations récentes en électricité et bâtiment général
              </div>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '30px',
                marginBottom: '40px'
              }}>
                <div style={{
                  position: 'relative',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 15px var(--ozarks-shadow)',
                  transition: 'transform 0.3s ease'
                }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <img src="/images/tild3033-3662-4530-a236-636430373231__cartoon_electrician_.jpg" alt="Installation électrique résidentielle" style={{width: '100%', height: '200px', objectFit: 'cover'}} />
                  <div style={{padding: '20px', backgroundColor: 'white'}}>
                    <h4 style={{color: 'var(--ozarks-blue-dark)', marginBottom: '10px', fontWeight: 600}}>Installation électrique résidentielle</h4>
                    <p style={{color: 'var(--ozarks-gray)', fontSize: '14px', lineHeight: '1.6'}}>Installation complète de prises et circuits électriques aux normes</p>
                  </div>
                </div>
                
                <div style={{
                  position: 'relative',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 15px var(--ozarks-shadow)',
                  transition: 'transform 0.3s ease'
                }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <img src="/images/tild3166-6234-4933-b961-643361313737__borne.png" alt="Borne de recharge IRVE" style={{width: '100%', height: '200px', objectFit: 'cover'}} />
                  <div style={{padding: '20px', backgroundColor: 'white'}}>
                    <h4 style={{color: 'var(--ozarks-blue-dark)', marginBottom: '10px', fontWeight: 600}}>Borne de recharge IRVE</h4>
                    <p style={{color: 'var(--ozarks-gray)', fontSize: '14px', lineHeight: '1.6'}}>Installation de bornes de recharge pour véhicules électriques certifiées</p>
                  </div>
                </div>
                
                <div style={{
                  position: 'relative',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 15px var(--ozarks-shadow)',
                  transition: 'transform 0.3s ease'
                }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <img src="/images/batiment/isolation-rockwool.jpg" alt="Isolation thermique" style={{width: '100%', height: '200px', objectFit: 'cover'}} />
                  <div style={{padding: '20px', backgroundColor: 'white'}}>
                    <h4 style={{color: 'var(--ozarks-blue-dark)', marginBottom: '10px', fontWeight: 600}}>Isolation thermique</h4>
                    <p style={{color: 'var(--ozarks-gray)', fontSize: '14px', lineHeight: '1.6'}}>Travaux d'isolation avec matériaux haute performance pour économies d'énergie</p>
                  </div>
                </div>
              </div>
              
              <Link 
                to="/batiment" 
                style={{
                  display: 'inline-block',
                  backgroundColor: 'var(--ozarks-blue-dark)',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: 500,
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--ozarks-blue-medium)';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--ozarks-blue-dark)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                Voir toutes nos réalisations →
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Section Notre méthode de travail */}
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px', backgroundColor: 'var(--ozarks-light-gray)'}}>
        <div className="t-container">
          <div className="t-col t-col_10 t-prefix_1">
            <div className="t-align_center">
              <h2 className="t-section__title t-title t-title_xs t-margin_auto" style={{marginBottom: '20px'}}>
                <span className="ozarks-blue-dark">Notre méthode</span> <span className="ozarks-blue-medium">de travail</span>
              </h2>
              <div className="t-descr t-descr_xl t-margin_auto" style={{marginBottom: '50px', color: 'var(--ozarks-gray)', maxWidth: '600px'}}>
                Une approche structurée pour garantir la qualité et la satisfaction de nos clients
              </div>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '30px',
                maxWidth: '1200px',
                margin: '0 auto'
              }} className="methode-travail-grid">
                <div style={{
                  backgroundColor: 'white',
                  padding: '30px 20px',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px var(--ozarks-shadow)',
                  textAlign: 'center',
                  transition: 'transform 0.3s ease'
                }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--ozarks-blue-light)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '24px'
                  }}>
                    📞
                  </div>
                  <h4 style={{color: 'var(--ozarks-blue-dark)', marginBottom: '15px', fontWeight: 600, fontSize: '18px'}}>1. Contact & Écoute</h4>
                  <p style={{color: 'var(--ozarks-gray)', fontSize: '16px', lineHeight: '1.6'}}>
                    Nous prenons le temps d'écouter vos besoins et d'analyser votre projet en détail
                  </p>
                </div>
                
                <div style={{
                  backgroundColor: 'white',
                  padding: '30px 20px',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px var(--ozarks-shadow)',
                  textAlign: 'center',
                  transition: 'transform 0.3s ease'
                }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--ozarks-blue-light)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '24px'
                  }}>
                    📋
                  </div>
                  <h4 style={{color: 'var(--ozarks-blue-dark)', marginBottom: '15px', fontWeight: 600, fontSize: '18px'}}>2. Étude & Devis</h4>
                  <p style={{color: 'var(--ozarks-gray)', fontSize: '16px', lineHeight: '1.6'}}>
                    Étude technique approfondie et proposition d'un devis détaillé et transparent
                  </p>
                </div>
                
                <div style={{
                  backgroundColor: 'white',
                  padding: '30px 20px',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px var(--ozarks-shadow)',
                  textAlign: 'center',
                  transition: 'transform 0.3s ease'
                }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--ozarks-blue-light)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '24px'
                  }}>
                    🔧
                  </div>
                  <h4 style={{color: 'var(--ozarks-blue-dark)', marginBottom: '15px', fontWeight: 600, fontSize: '18px'}}>3. Réalisation</h4>
                  <p style={{color: 'var(--ozarks-gray)', fontSize: '16px', lineHeight: '1.6'}}>
                    Intervention professionnelle dans le respect des délais et des normes de sécurité
                  </p>
                </div>
                
                <div style={{
                  backgroundColor: 'white',
                  padding: '30px 20px',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px var(--ozarks-shadow)',
                  textAlign: 'center',
                  transition: 'transform 0.3s ease'
                }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--ozarks-blue-light)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '24px'
                  }}>
                    ✅
                  </div>
                  <h4 style={{color: 'var(--ozarks-blue-dark)', marginBottom: '15px', fontWeight: 600, fontSize: '18px'}}>4. Contrôle & SAV</h4>
                  <p style={{color: 'var(--ozarks-gray)', fontSize: '16px', lineHeight: '1.6'}}>
                    Vérification finale et service après-vente pour votre totale satisfaction
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Home;